module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAPCAYAAAAYjcSfAAAA8klEQVQ4jb3NIU/DUBQG0EP/GQQSQkAwcAgcDgVyKIIFNTs3NzcMCDI1MzUBBjyCZMkSQJA0xdwmS6FpC9s+9+697ztrrSy7RNvqcpXgAtcrAm/QTuJxjs6SwQ7OIEcznKK7JLAb/dk8msMn6C0Y7EVvlg+SwkGKY/QXBPajL50fFtEcPsLgn+Bt9KTFxW8ofOEQd38E73EQPT9ShuZwC8OG4BD7ZWAVCp/YxagmOMJe/CtNFQof2MG44m4cd+9VhXVQmGEbk5L9JPazOmV1UZhiC4+F+VPMp3WLmqDwFsBzvF+wGfPaaYrCKzbwgPV4N8o3p9M3+2B7PhwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/video/down.png
// module id = 582
// module chunks = 2